import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Route, Switch } from 'react-router'; // react-router v4
import { ConnectedRouter, push, goBack } from 'connected-react-router';
import styled from 'styled-components';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { State } from 'src/state/ducks';

import AuthHandler, { AdminHandler } from 'src/container/AuthHandler';
import LoadingContainer from 'src/container/util/LoadingContainer';
import IndexPage from 'src/container/IndexPage';
import ErrorPage from 'src/container/error/ErrorPage';
import { HistoryProps, DefaultPageProps } from 'src/constants/Interface';
import * as adminActions from 'src/state/ducks/admin/actions';
import { RegisterRoutes, AdminRoutes, ShopRoutes, OrderRoutes } from 'src/container/routes';

type Props = DefaultPageProps &
  HistoryProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class AppContainer extends Component<Props> {
  render() {
    const { history, isSignIn, isUserFetching } = this.props;
    if (isUserFetching) return <LoadingContainer />;
    return (
      <ConnectedRouter history={history}>
        <Fragment>
          <RegisterRoutes {...this.props} />
          <AuthHandler isSignIn={isSignIn}>
            <Switch>
              <Route exact path="/" render={() => <IndexPage {...this.props} />} />
              {ShopRoutes({ ...this.props })}
              {OrderRoutes({ ...this.props })}
              <AdminHandler user={this.props.user}>{AdminRoutes({ ...this.props })}</AdminHandler>
            </Switch>
          </AuthHandler>
          <Route exact path={'/error'} render={() => <ErrorPage {...this.props} />} />
        </Fragment>
        <ToastWrapper>
          <ToastContainer
            position="bottom-center"
            transition={Slide}
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </ToastWrapper>
      </ConnectedRouter>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    isUserFetching: state.admin.isFetching,
    isSignIn: state.admin.isSignIn,
    user: state.admin.user,
    login_shop_id: state.admin.login_shop_id,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    pushUrl: (url: string) => dispatch(push(url)),
    goBackUrl: () => dispatch(goBack()),
    handleLogOut: () => dispatch(adminActions.logout()),
  };
};

const ToastWrapper = styled.div`
  .Toastify__toast-body {
    text-align: center;
  }
`;

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
